
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.Task">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-task-message-modal [taskViewModel]="data.taskViewModel" [invokedFromTheCase]="data.invokedFromTheCase" (supplierInvoiceMovedEvent)="data.supplierInvoiceMoved" (taskUpdatedEvent)="taskUpdated()" (closed)="close()"></app-task-message-modal>
    </mat-dialog-content>
</div>
